import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export const BankCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    // Customer create
    const [bankname, setBankName] = useState("");
    const [ifsccode, setIFSCCode] = useState("");
    const [accNumber, setACCNumber] = useState("");
    const [openingbalance, setOpeningBalance] = useState("");
    const [branch, setBranch] = useState("");
    const [upino, setUPINo] = useState("");
    const [isPrimaryUpi, setIsPrimaryUpi] = useState("");

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const [selectedPaymentType, setSelectedPaymentType] = useState("");
    const handleChange = (event) => {
        setSelectedPaymentType(event.target.value);
    };

    // Customer Payment Method 
    const [selectedPaymentmethod, setSelectedPaymentmethod] = useState("");
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('AccountTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!bankname || !accNumber || !ifsccode || !branch) {
            setErrorMessages("All fields are required!");
            setIsLoading(false);
            return;
        }

        try {
            const BankCreateData = {
                BankName: bankname,
                CompanyId: companyId,
                AccountType: selectedPaymentmethodType.value,
                IFSC: ifsccode,
                AccountNo: accNumber,
                Branch: branch,
                OpeningBalance: openingbalance,
                UPINo: upino,
                IsPrimaryUpi: isPrimaryUpi === "1",
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('Bank', BankCreateData, token)
                .then((response) => {
                    console.log('Bank Created success:', response);
                    setBankName("");
                    setIFSCCode("");
                    setACCNumber("");
                    setBranch("");
                    setOpeningBalance("");
                    setUPINo("");
                    setSelectedPaymentmethodType("");
                    setSuccessMessages("Bank Created successfully!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/BankIndex');
                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('Bank Create error:', error);
                    setIsLoading(false);
                });

        } catch (error) {
            console.error('Bank Create error:', error);
        }
    };
    
    /* End API */

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <div className="w-full mb-4 flex">
                    <form onSubmit={submitData}>
                        <div className='w-full mb-2 flex items-center'>
                            <h4 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Bank Create</h4>

                            <Tooltip title="Exit">
                                <Link to="/BankIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                    <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                        Back-To-List <ExitToAppIcon />
                                    </Button>
                                </Link>
                            </Tooltip>

                            <Tooltip title="SAVE">
                                <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                </Button>
                            </Tooltip>
                        </div>
                        {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                        {successMessages && <p className="text-green-500">{successMessages}</p>}
                        <br></br>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="BankName">
                                    Bank Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={bankname}
                                    onChange={(e) => setBankName(e.target.value)}
                                    type="text"
                                    placeholder="Enter Bank Name"
                                    maxLength={50}
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AccountNo">
                                    Account No
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={accNumber}
                                    onChange={(e) => {
                                        const input = e.target.value.replace(/\D/g, '');
                                        if (input.length <= 20) {
                                            setACCNumber(input);
                                        }
                                    }}
                                    type="text"
                                    placeholder="Enter Account No"
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="IFSC">
                                    IFSC Code
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={ifsccode}
                                    onChange={(e) => setIFSCCode(e.target.value)}
                                    type="text"
                                    placeholder="Enter IFSC Code"
                                    maxLength={20}
                                />
                            </div>
                            <div className="w-1/3 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Branch">
                                    Branch
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={branch}
                                    onChange={(e) => setBranch(e.target.value)}
                                    type="text"
                                    placeholder="Enter Branch"
                                    maxLength={50}
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="OpeningBalance">
                                    Opening Balance
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={openingbalance}
                                    onChange={(e) => {
                                        let input = e.target.value.replace(/[^\d.]/g, ''); // Replace any non-digit and non-dot characters
                                        const parts = input.split('.');
                                        if (parts.length > 2) {
                                            parts.pop(); // Remove extra dots
                                            input = parts.join('.');
                                        }
                                        if (parts[1] && parts[1].length > 4) {
                                            input = `${parts[0]}.${parts[1].slice(0, 4)}`; // Limit to 4 digits after the dot
                                        }
                                        setOpeningBalance(input);
                                    }}
                                    type="text"
                                    placeholder="Opening Balance"
                                    maxLength={10}
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                    Account Type
                                </label>
                                <Select
                                    value={selectedPaymentmethodType}
                                    onChange={handlePaymentTypeChange}
                                    options={paymentmethodOptions}
                                    placeholder="Account Type"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="UPINo">
                                    UPI ID
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={upino}
                                    onChange={(e) => setUPINo(e.target.value)}
                                    type="text"
                                    placeholder="Enter Your UPI ID"
                                    maxLength={45}
                                />
                            </div>
                            <div className="w-1/2 radio-group" style={{ marginLeft: '10px' }}>
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="isPrimaryUpi">
                                    Primary UPI ID
                                </label>
                                <div className="flex items-center">
                                    <label className="block uppercase tracking-wide font-bold mr-2" style={{ color: 'darkgreen' }}>
                                        <input type="radio" name="isPrimaryUpi" value="1" checked={isPrimaryUpi === "1"} onChange={() => setIsPrimaryUpi("1")} />
                                        Yes
                                    </label>
                                    <label className="block uppercase tracking-wide font-bold mr-2" style={{ color: 'darkred' }}>
                                        <input type="radio" name="isPrimaryUpi" value="0" checked={isPrimaryUpi === "0"} onChange={() => setIsPrimaryUpi("0")} />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    );
}
